import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["primary", "secondary"];

  toggle() {
    this.primaryTarget.toggleAttribute("hidden");
    this.secondaryTarget.toggleAttribute("hidden");
  }
}
